<h2 mat-dialog-title>{{this.title ?? "Delete Confirmation"}}</h2>
<div mat-dialog-content>
    <p>{{this.content ?? "Are you sure you want to delete the selected?"}}</p>


</div>
<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]=false>Close</button>
    <button mat-raised-button [mat-dialog-close]=true>{{this.proceedButtonText ??'Delete'}}</button>
</div>